import { motion } from 'framer-motion';
import { HiCheck } from 'react-icons/hi';
import './Pricing.scss';
import { useEffect } from 'react';

const pricingPlans = [
  {
    name: 'Basic',
    subtitle: '로컬버전',
    price: '33,000',
    period: '월',
    color: '#999999',
    popular: false,
    discontinued: false,
    features: [
      { text: '최소 기본 기능', highlight: false },
      { text: 'DB 구축 (HWP + PDF)', highlight: false },
      { text: '문제 출제', highlight: false },
      { text: '미리보기 & 프린트', highlight: false },
      { text: '시험지 저장', highlight: false },
    
    ],
  },
  {
    name: 'Pro',
    subtitle: '서버버전',
    price: '66,000',
    period: '월',
    color: '#FF6B35',
    popular: true,
    features: [
      { text: '가입비 0원', highlight: true },
      { text: '인원수 제한 : 100명', highlight: true },
      { text: '정기 업데이트 진행 중', highlight: true },
      { text: '학생 100명 초과 시 별도 문의', highlight: false },
      { text: 'Basic의 모든 기능', highlight: false },
      { text: '오답 관리 및 기타', highlight: false },
      { text: '모바일 앱 마킹 & 학습', highlight: false },
    ],
  },
];

const Pricing = () => {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main className="pricing">
      <section className="pricing__hero">
        <div className="container">
          <motion.div
            className="pricing__header"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
  
            <h1 className="pricing__title">
              선생님들을 위한
              <span className="text-success"> 아래한글 기반의</span> 문제은행
            </h1>
            <p className="pricing__subtitle text-danger">
              독보적인 기술력 <span className="text-dark">매쓰오토젠</span>
            </p>
            <p className="pricing__description">
              방대한 기능의 집합체, 만물 백화점처럼 없는 게 없는 솔루션
            </p>
            <p className="pricing__description">
              정기 업데이트를 통해 더욱 강력하고 정확한 DB 구축을 지원합니다
            </p>
          </motion.div>
        </div>
      </section>

      <section className="pricing__cards section">
        <div className="container">
          <div className="pricing__grid">
            {pricingPlans.map((plan, index) => (
              <motion.article
                key={index}
                className={`pricing__card ${plan.popular ? 'pricing__card--popular' : ''}`}
                initial={{ opacity: 0, y: 50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.2 }}
                style={{ '--accent': plan.color }}
              >
        
                <div className="pricing__card-header">
                  <h2 className="pricing__card-name">{plan.name}</h2>
                  <p className="pricing__card-subtitle">{plan.subtitle}</p>
                </div>
                <div className="pricing__card-price">
                  <span className="pricing__card-amount">
                    <span className="pricing__card-highlight">
                      {plan.price}원
                    </span>
                  </span>
                  <span className="pricing__card-period">/{plan.period}</span>
                </div>
                <p className="pricing__card-vat">(부가세 포함)</p>
                <ul className="pricing__card-features">
                  {plan.features.map((feature, i) => (
                    <li key={i} className={`pricing__card-feature ${feature.highlight ? 'pricing__card-feature--highlight' : ''}`}>
                      <HiCheck size={18} />
                      {feature.text}
                    </li>
                  ))}
                </ul>
  
              </motion.article>
            ))}
          </div>
        </div>
      </section>

    </main>
  );
};

export default Pricing;

